import Shortcut from "../shortcut/Shortcut";
import Empty from "./Empty";
import Group from "./Group";
import Item from "./Item";
import List from "./List";
import Root from "./Root";
import Search from "./Search";
import Separator from "./Separator";

export const Command = {
  Root,
  Search,
  List,
  Shortcut,
  Empty,
  Group,
  Item,
  Separator,
};

export type { ShortcutProps as CommandShortcutProps } from "../shortcut/Shortcut";
export type { CommandEmptyProps } from "./Empty";
export type { CommandGroupProps } from "./Group";
export type { CommandItemProps } from "./Item";
export type { CommandListProps } from "./List";
export type { CommandRootProps } from "./Root";
export type { CommandSearchProps } from "./Search";
export type { CommandSeparatorProps } from "./Separator";
